import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Lookup } from 'src/app/models/Lookup';
import { ResActionsService } from '../../ResActions.service';
import { FormControl, Validators } from '@angular/forms';
import { Patterns } from 'src/app/helpers/patterns';
import { openPrintWindow } from 'src/app/helpers/print.helper';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

export interface DialogData {
  isOwner: boolean
  restaurantId: number
}
@Component({
  selector: 'app-till-amount-confirm',
  templateUrl: './till-amount-confirm.component.html'
})
export class TillAmountConfirmComponent implements OnInit {
  loading = false;
  tillAmount = new FormControl(null, [
    Validators.required,
    Validators.pattern(Patterns.price2decimal)
  ]);
  userId: any = new FormControl(null);

  users: Lookup[] = [];
  usersLoading = false;
  isSubmitted = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<TillAmountConfirmComponent>,
    private service: ResActionsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    if (this.data.isOwner) {
      this.userId = new FormControl(null, Validators.required);
      this.GetAllCashierRestaurantTeam();
    }
  }

  submit() {
    this.isSubmitted = true;
    this.tillAmount.markAllAsTouched();
    this.userId.markAllAsTouched();

    if (this.tillAmount.valid && this.userId.valid) {
      this.printTill();
      // this.dialogRef.close({
      //   amount: this.tillAmount.value,
      //   userId: this.userId.value
      // })
    }
  }

  GetAllCashierRestaurantTeam() {
    this.usersLoading = true;
    this.service.GetAllCashierRestaurantTeam(this.data.restaurantId).subscribe(
      (result: any) => {
        this.usersLoading = false;
        this.users = result;
        if (this.users.length) {
          this.userId.setValue(this.users[0].id);
        }
      }, err => {
        console.error(err);
      });
  }

  printTill() {
    this.loading = true;
    let data: any = {
      restaurantId: this.data.restaurantId,
      userId: this.userId.value,
      amount: Number(this.tillAmount.value)
    };
    let isApp = false;
    if (localStorage.getItem('deviceId')) {
      isApp = true;
      data.deviceId = localStorage.getItem('deviceId');
      data.deviceType = localStorage.getItem('deviceType');
    }
    this.service.PrintTill(data).subscribe(
      (data: any) => {
        // this.loading = false;
        if (!isApp) {
          setTimeout(() => { this.print(data.htmlContent); }, 500);
        }
        this.dialogRef.close();
      }, error => {
        this.loading = false;;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
  }

  print(html: string): void {
    const mywindow: any = openPrintWindow('height=600,width=700');
    if (!mywindow) {
      return;
    }
    mywindow.document.write(html);

    mywindow.document.close();
    mywindow.focus();

    mywindow.onload = () => {
      mywindow.print();
    };
  }
}
